// login/config.js
export const config = {
    AWS_REGION: "ap-south-1",
    COGNITO_USER_POOL_ID: "ap-south-1_fW9r4gqCn",
    COGNITO_USER_POOL_CLIENT_ID: "2lq99dqh5lvvmir3u3s5q9kdst", 
    COGNITO_DOMAIN: "ap-south-1fw9r4gqcn",
    GOOGLE_CLIENT_ID: "167482091655-pdtkkegbm5no6l0lunf11hbok69g9j02.apps.googleusercontent.com"
  };
